import React from 'react';

import {
  StepContainer,
  FormNavigation
} from 'components/CASAForm';

interface GenericStepProps {
  title?: string;
  nextButtonText?: string;
  backButtonText?: string;
  showSaveAndExit?: boolean;
  customHandleBack?: (e: React.MouseEvent<HTMLElement>) => void;
  hideNext?: boolean;
  hidePrevious?: boolean;
  triggerFormValidation?: boolean;

  onPreviousAction?: () => void;
  onNextAction?: () => void;
}

const GenericStep: React.FC<GenericStepProps> = ({
  children,
  title,
  ...props
}) => {
  return (
    <StepContainer {...props}>
      <h2>{title}</h2>
      {children}

      <FormNavigation {...props} />
    </StepContainer>
  );
};

export default GenericStep;
